<template>
  <div class="trial-content">
    <div class="trial-content-num">
      <div class="bg">
        <NavBar></NavBar>
        <!-- <div class="go-back">
          <span @click="goBack"> {{ $t("Go Back") }}</span>
        </div> -->
        <div class="top-cont">
          <div class="left">
            <div class="left-comment">
              <h3> {{$t('Why 20000+ Parents Choose Classover?')}} </h3>
              <div>
                <div>
                  <img src="../assets/img/Icontrial.png" alt=""> 
                  <span>{{$t('Unlimited live lessons for One Flat Fee')}} </span>
                </div>
                <div>
                  <img src="../assets/img/Icontrial.png" alt=""> 
                  <span>{{$t('Top certified teachers in America')}} </span>
                </div>
                <div>
                  <img src="../assets/img/Icontrial.png" alt=""> 
                  <span>{{$t('100% live and teacher-led small group classes')}} </span>
                </div>
                 <div>
                  <img src="../assets/img/Icontrial.png" alt=""> 
                  <span>{{$t('Customizable courses with flexible schedule')}} </span>
                </div>
              </div>
             
            </div>
              <div class="img1"></div>
              <!-- <img class="img1" src="../assets/img/Vectoreadus.png" alt=""> -->
              <img class="img2"  src="../assets/img/h.png" alt="">
              <img class="img3"  src="../assets/img/chess.png" alt="">
              <img class="img4"  src="../assets/img/Vectoreadus.png" alt="">
              <img class="img5"  src="../assets/img/reading.png" alt="">
              <img class="img6"  src="../assets/img/f.png" alt="">
              <img class="img7"  src="../assets/img/icons.png" alt="">
              <img class="img8"  src="../assets/img/Group 11119.png" alt="">
               <img class="img9"  src="../assets/img/Framemin.png" alt="">
          </div>
          <div class="right main-top">
            <div class="class-form">
              <div class="wp-form">
                <h2>{{$t('Free Trial Lesson')}} </h2>
                <el-form :model="formLabelAlign" :rules="rules" ref="formLabelAlign" :hide-required-asterisk="true" label-position="top">  
                  <el-form-item
                    prop="nickname"
                    :label="$t('Kid(s) Nickname')"
                  >
                    <el-input class="wp-input" v-model="formLabelAlign.nickname" :placeholder="$t('Kid(s) Nickname')"></el-input>
                  </el-form-item>
                  <el-form-item
                    prop="mobile"
                    :label="$t('Phone Number')"
                  >
                    <el-input oninput="value=value.replace(/\D/gi,'')" class="wp-input"  :placeholder="$t('Phone numberfree')" v-model="formLabelAlign.mobile" :maxlength="max">
                    <el-select ref="select" :placeholder="$t('Country Code')"  v-model="formLabelAlign.country_code" slot="prepend" class="selectcss"  @change="changeCode">
                      <el-option v-for="(item, index) in countries" :label="` ${item.title} `" :key="item" :value="item.id">
                        <div class="selectoption">
                            <span> <img :src="item.flag" alt=""> {{item.title}} </span> 
                            <span> +{{ item.country_code }}</span>
                        </div>                      
                    </el-option>
                    </el-select>
                    </el-input>
                  </el-form-item>
                  <el-form-item
                    prop="email"
                    :label="$t('Email Address* (Required)')"
                  >
                    <el-input class="wp-input" v-model="formLabelAlign.email" placeholder="example@gmail.com"></el-input>
                  </el-form-item>
                  
                  <el-form-item prop="wechat_id" :label="$t('WeChat ID')">
                    <el-input class="wp-input" v-model="formLabelAlign.wechat_id" placeholder="wechat ID"></el-input>
                  </el-form-item>
                  <el-form-item prop="coupon_code" :label="$t('Coupon Code')">
                    <el-input class="wp-input" v-model="formLabelAlign.coupon_code" placeholder="Coupon Code"></el-input>
                  </el-form-item>
                  <el-form-item style="margin:0">
                    <el-button class="wp-button primary" :loading="loading" @click="submit">{{
                      $t("Claim Free Lesson")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </div>

            <div class="imgbox">
              <img  class="imggr1" src="../assets/img/Rectangle 9.png" alt="">
              <img class="imggr3" src="../assets/img/Rectangle 10.png" alt="">
              <img class="imggr4" src="../assets/img/Rectangle 12.png" alt="">
              <img class="imggr5" src="../../../../app/build-artifacts/official-examination-center-2025.png" alt="">
            </div>

          </div>
        </div>
      </div>
    </div>
        <div v-show="dialogVisible" class="show-captcha" @click="closebg">
        <div  class="show-captcha-div" @click.stop>
          <div>

          
                <div ref="captcha" ></div>
                <!-- <button ref="popups" class=" captcha-botton"> {{$t('Click Refresh Verification Code')}}</button> -->
          </div>       <!-- <el-button ref="popups" type="primary" > {{$t('Click Refresh Verification Code')}} </el-button>           -->
        </div>
        </div>
  </div>
</template>

<script>
import { joinUser, getCountries, recordClick,getImgCode } from "../api";
import { loadingData } from "../utils";
/*  import { LoginRedirect } from "../services/redirectService"; */
import { setStore, keys } from "../store";
import NavBar from '@/components/NavBar.vue';
import WpFooter from "@/components/WpFooter.vue";

// import pullRefresh from '../components/PullRefresh.vue';
import i18n from "../locales/i18n";

export default {
  components: {
    NavBar,
    WpFooter
  },
  name: "History",
  data() {
    return {
      max:10,
      min:1,
      lang: "",
				loading:false,
      form: {
        name: "",
        email: "",
        wechat: ""
      },
      
      countries: [],
      formLabelAlign: {
        nickname: '',
        email: '',
        mobile: '',
        country_code:'',
        wechat_id:'',
        code:'',
        coupon_code:''
      },
      rules: {
        nickname: [
          {
            required: true,
            message: i18n.t("Please enter your full name"),
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: i18n.t("Please enter your email"),
            trigger: "blur"
          },
          {
            type: "email",
            message: i18n.t("Please enter the correct email address"),
            trigger: ["blur", "change"]
          }
        ],
        mobile: [
          {
            required: true,
            message: i18n.t("Please enter your mobile phone number"),
            trigger: "blur"
          },
           {
             min:10,
            message: i18n.t("Incorrect mobile number format"),
            trigger: "blur"
          }
        ],
      },
      four_img: [
        {
          img: require("@/../src/assets/img/icon3 1.png"),
          text: "Unlimited llve lessons One Flat Fee"
        },
        {
          img: require("@/../src/assets/img/icons2-02 1.png"),
          text: "Top certified teachers in America"
        },
        {
          img: require("@/../src/assets/img/icon4--05 1.png"),
          text: "100% live and teacher-led small group classes"
        },
        {
          img: require("@/../src/assets/img/shutterstock_1900409038 [Converted]-03 1.png"),
          text: " Customizable courses with flexible schedule"
        }
      ],
      comment: {
        index: 0,
        count: 4
      },
      flag:'',
      id:'',
      identifyCode: [],
      input:'',
      screenWidth:'',
      messagecode:false,
      dialogVisible:false
    };
  },
  created(){
           this.id=this.$route.params.id
           if(this.$route.params.id){
             this.$router.push({ params: {id:''},query:{utm_id:this.$route.query.utm_id,utm_source:this.$route.query.utm_source?this.$route.query.utm_source:'official_website',utm_medium:this.$route.query.utm_medium?this.$route.query.utm_medium:'register',utm_campaign:this.$route.query.utm_campaign?this.$route.query.utm_campaign:''} }); 
           }
           function gethtmlfontsize(){
              // 三个步骤:
              // 1.获取html的高,
              let htmlheight=document.documentElement.clientHeight || document.body.clientHeight;//有些浏览器documentElement获取不到,那就使用后面的body
              console.log(htmlheight);    
              // 2.htmlDom
              let htmlDom=document.getElementsByTagName("html")[0]
              // console.log(htmlDom);
              //3.设置根元素样式
              htmlDom.style.fontSize=100*htmlheight/375+'px';
              
            htmlDom.style.height = '100%';
            }
            // 调用一次
            gethtmlfontsize();
            // 添加监听事件(resize是监听的意思)
            window.addEventListener('resize',gethtmlfontsize)
			            
		},
  mounted() {
			loadingData(async () => {
				let result = await getCountries({});
				this.countries = result.map((item) => {
					return { id: item.id,title:item.title, name:'+'+item.country_code+' '+ item.title, country_code: item.country_code,flag:item.flag };
				});
        //  this.formLabelAlign.country_code = this.countries[0].id
        //     this.formLabelAlign.code = this.countries[0].country_code
			});
    this.lang = i18n.locale;
    	if( this.id){
					if(this.id=='en'){
						i18n.locale=this.lang='en'
						setStore('lang',i18n.locale)
					}
					else if(this.id=='cn'){
						i18n.locale=this.lang='zh_CN'
						setStore('lang',i18n.locale)
					}
			}
       var that=this
       that.screenWidth  =document.body.clientWidth ||window.screenWidth;
        window.addEventListener("resize", function() {
                        return(() => {
                         that.screenWidth  =document.body.clientWidth ||window.screenWidth;
                            //  console.log(that.screenWidth)
                        })();
                    });
    var tag="<span>"+this.formLabelAlign.code+"</span> "; 
        var img="<img >"
        this.$refs['select'].$el.children[0].children[0].insertAdjacentHTML("beforeBegin",img);   
              this.$refs['select'].$el.children[0].children[0].setAttribute(
            'style',
            'display:none;'
          ) 
        this.$refs['select'].$el.children[0].children[2].children[0].insertAdjacentHTML("beforeBegin",tag);
        var self = this;
		    var options = {
		      element: this.$refs.captcha,
		      captchaId: "2e3422055bf14588a401899f1d8b25b6",
		      width: "320px",
              mode: 'embed',
              apiVersion: 2,
              lang :i18n.locale=='en'?'en':'zh-CN',
              onVerify:(err,data)=>{   //验证之后的回调函数,err验证失败才有值
                  if (err){
                    this.input=''
                    return
                  } 
                  if(data){
                    // console.log(data.validate)
                      this.input=data.validate
                      this.dialogVisible=false
                      this.submit()
                       self.instance && self.instance.refresh();
                    //    console.log(data.validate)
                  }
              }
		    };
		    initNECaptcha(options, function onLoad(instance) { //初始化成功
		    //   console.log(instance);
		      self.instance = instance;
		    },
            function onerror (err) { //初始化失败
                console.log(err)
            }
            );
		    this.$refs.popups.addEventListener("click", function() {
          // console.log('111')
		      self.instance && self.instance.refresh();
		    });
  },
  computed: {
    device() {
      return window.innerWidth > 768 ? "pc" : "mobile";
    },
    langText() {
      return this.lang === "en" ? "English" : "简体中文";
    },
    ispc() {
      return window.innerWidth > 768 ? true : false;
    }
  },
  methods: {
     changeCode(){
        this.countries.map((item) => {
            if(this.formLabelAlign.country_code == item.id){
                this.formLabelAlign.code = item.country_code
                 this.flag=item.flag
            }
        });
        if(this.formLabelAlign.code=='86'){
          if(this.formLabelAlign.mobile.length>11){
            this.formLabelAlign.mobile = ''
          }
          this.max = 11
          // this.rules.mobile[1].min = 1
        }else if(this.formLabelAlign.code=='1'){
          if(this.formLabelAlign.mobile.length>10){
            this.formLabelAlign.mobile = ''
          }
          this.max = 10
        }else{
          this.max=15
        }
        this.$refs['select'].$el.children[0].children[1].setAttribute(
            'style',
            // 'background:url('+ this.flag +') no-repeat;background-size: 21px 15px;background-position: 12px 13px;padding: 0 52px  0   49px; color: #111827;font-family: "Inter";font-weight: 500;font-size: 14px;'
            'padding: 0 0px 0 40px;'
          )   
        this.$refs['select'].$el.children[0].children[0].src=this.flag; 
        this.$refs['select'].$el.children[0].children[0].setAttribute(
            'style',
            'display:block;'
          )         
          this.$refs['select'].$el.children[0].children[2].children[0].innerHTML="+"+this.formLabelAlign.code;
      },
    goBack() {
      history.back();
    },
    closebg(){
      this.dialogVisible=false
    },
    submit() {
				this.$refs.formLabelAlign.validate((valid) => {
					if (valid) {
            if(!this.formLabelAlign.country_code){
              alert(i18n.t('Please select your country code'))
              return false
            }
            if(this.input==''){
                                this.dialogVisible=true
                                return
                            }else{
            loadingData(async () => {
                let userInfo = await joinUser(
                   { 
                      mobile:this.formLabelAlign.mobile, 
                      email: this.formLabelAlign.email,  
                      country_code: this.formLabelAlign.code,  
                      child_nickname: this.formLabelAlign.nickname,
                      wechat_id: this.formLabelAlign.wechat_id,
                      coupon_code: this.formLabelAlign.coupon_code,
                      landingpage_id :9,
                      utm_source:this.$route.query.utm_source?this.$route.query.utm_source:'official_website',
                      utm_medium:this.$route.query.utm_medium?this.$route.query.utm_medium:'register',
                      utm_campaign:this.$route.query.utm_campaign?this.$route.query.utm_campaign:'',
                        captcha:this.input,
                      ...this.$route.query
                   }
                );
                this.input='' 
                setStore(keys.userInfo, userInfo);
                // if (userInfo.is_register){
                  await recordClick(2,userInfo.user_sn,'landingpage-id:9');
                // }
                if (userInfo.name) this.$router.push({ path: '/salecard',query:{invite_code:userInfo.invite_code} });
                // setTimeout(() => {
                //   if (userInfo.name) this.$router.push({ path: '/salecard',query:{invite_code:userInfo.invite_code} });
                // }, 1000);
            });
          }}
        })
    },
    commentClick(value) {
      console.log(value);
      let nextIndex = this.comment.index + value;
      if (nextIndex < 0) return;
      if (nextIndex + 3 > this.comment.count) return;

      this.$refs.overContainer.scrollLeft = nextIndex * 330;
      this.comment.index = nextIndex;
    }
  }
};
</script>

<style lang="less" scoped>
.captcha-botton{
  width: 90%;
  height: 40px;
   border-radius:6px;
   cursor: pointer;
       background-color: #409eff;
    border-color: #409eff;
    color: #fff;
    border: none;
}
//图片滑动验证码样式
.show-captcha{
   position: fixed;
   display: flex;
   justify-content:center;
   align-items:center;
   top: 0%;
   left: 0%;
   right: 0;
   bottom: 0;
   background-color: rgba(0, 0, 0, 0.3);
   z-index: 99999999999;
   .show-captcha-div{
       display: flex;
       justify-content : center;
       align-items:center;
       flex-direction:column;
       width: 350px;
       height: 350px;
       background: #fff;
       padding: 5px 5px;
       position: relative;
       div{
         text-align: center;
         box-sizing: border-box;
       }
      //  div{
      //     //  position: absolute;
      //      bottom: 60px;
      //     //  width: 90%;
      //      left: calc( 50% - 160px );
      //  }
       button{
          //  position: absolute;
          //  bottom: 10px;
           width: 80%;
           margin-top: 20px;
          //  left: 10%;
       }
       
   }
}
//原来的验证码样式
/deep/.captchaimg{
    // width: 40%;
    margin-bottom: 20px;
}
/deep/.el-dialog{
    text-align: center;
    padding: 10px 20px;
    .el-input{
        width: 80%;
    }
}
/deep/.el-dialog__footer{
    text-align: center;
}
/deep/.el-dialog__wrapper{
    z-index: 99999999999 !important;
}
.dialog-span{
    margin-bottom: 30px;
    display: block;
}
.s-canvas{
    margin-bottom: 20px;
}
/deep/.el-form-item__content{
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
}
/deep/.el-select .el-input {
    img{
        width: 17px;
        position: absolute;
        left: 12px;
        bottom: 17px;
    }
}

/deep/.el-input{
  input{
    font-family: 'Sofia Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
  }
}
.selectoption{
        width: 280px;
        display: flex;
        justify-content:space-between;
        img{
            width: 15px;
            margin-right: 16px;
        }
        span{
            display: flex;
            align-items: center;
            font-family: 'Inter';
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            
            color: #111827;
        }
    }

/deep/.el-select .el-input .el-input__icon{
    width: 7px;
    font-size: 9px;
    padding-right: 7px;
}
    /deep/.el-input__suffix{
        display: flex;
        align-items:center;
        margin: auto;
        span:nth-child(1){
            display: block;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 20px;
            margin: auto;
            padding-left: 5px;
            color: #111827;
            // width: 30px;
                }

    }
@media screen and (min-width: @device) {
  .trial-content{
    height: 100vh;
    overflow: hidden;
    .trial-content-num{
      height: 100%;
    }
  }
  .bg {
    background:  #FFFFFF; 
    height: 100%;
    .top-cont{
      display: flex;
      height: calc(100% - 92px);
      flex: 1;
      // min-height: 970px;
      .left{
        position: relative;
        flex: 1;
        background: #ECF2FF;
        // height: calc(100vh - 81px);
        // overflow: hidden;
        .left-comment{
          // position: absolute;
          // z-index: 999999;
          // width: 2.78rem;
          margin: 0.29rem auto 0;
          text-align: center;
          h3{
            font-family: 'Sofia Pro Bold';
            font-style: normal;
            font-weight: 700;
            font-size: 0.145rem;
            line-height: 0.17rem;
            margin: 0 0 0.17rem;
            color: #111827;
          }
          div{
            display: table;
            // flex-direction:column;
            margin: 0 auto;
            // margin: 0 auto;

          }
          div>div{
            margin: 0;
            // display: flex;
            // flex-direction:row;
            text-align: left; 
            margin-bottom: 0.095rem;
            // display: flex;
            // align-items: center;
            img{
              width: 0.056rem;
              height: 0.045rem;
              margin-right: 0.067rem;
            }
            span{
              font-family: 'Sofia Pro SemiBold';
              font-style: normal;
              font-weight: 500;
              font-size: 0.085rem;
              line-height: 0.095rem;
              color: #111827;
            }
          }
        }

      }
      .right{
        flex: 1;
        background: #F5F5F5;
      }
      .img1{
        position: absolute;
        top: 0px;
        left: 0.045rem;
        height: 0.085rem;
        width: 0.17rem;
        border-radius: 0  0 100px 100px;
        background: linear-gradient(148.99deg, #A8C6FF 18.77%, rgba(49, 56, 232, 0.5) 100.66%);
        // transform: matrix(0.96, -0.28, 0.28, 0.96, 0, 0);
      }
      .img2{
        position: absolute;
        top: 0.28rem;
        left: 0.077rem;
        width: 0.16rem;
      }
      .img3{
        position: absolute;
        right:-0.162rem;
        top: 0.25rem;
        width: 0.324rem;
      }
      .img4{
        position: absolute;
        top:1.89rem;
        left: 0.52rem;
        width: 10px;
      }
      .img5{
        position: absolute;
        top:1.92rem;
        left:0.3rem;
        width: 0.24rem;
      }
      .img6{
        position: absolute;
        top: 1.95rem;
        right: 0.74rem;
        width: 0.18rem;
      }
      .img7{
        position: absolute;
        top: 2.44rem;
        right: 0px;
        width: 0.26rem;
      }
      .img8{
        position: absolute;
        bottom: 0;
        width: 2.3rem;
        left: calc(50% - 1.15rem);
      }
      .img9{
        display: none;
      }
    }
  }
  
  .main-top {
    display: flex;
    flex-direction:column;
    // justify-content: space-between;
    p {
      background-color: #fff;
      border-radius: 50%;
      width: 85px;
      height: 85px;
      display: flex;
      align-items: center;
      flex-direction: column;
      position: relative;
      margin: 0 27px 10px 0;
      img {
        position: absolute;
        top: -10px;
        left: center;
        width: 80px;
      }
      > span {
        position: absolute;
        text-align: center;
        top: 55px;
        left: center;
      }
    }
    .right-reviews{
          width: 488px;
          margin: 38px auto 0;
          display: flex;
          flex-direction:column;
          span{
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 300;
            font-size: 16px;
            line-height: 22px;
            color: #000000;
            span{
              font-weight: 700;
            }
          }
          img{
            width: 319px;
            margin-bottom: 10px;
          }
          div{
            margin-bottom: 15px;
            display: flex;
            align-items: center;
            img{
              width: 25.36px;
              height: 24px;
              margin: 0;
            }
            span{
              font-weight: 500;
              font-size: 24px;
              line-height: 26px;
            }
          }
    }
    
    .class-form {
      margin: 0.17rem auto 0;
      // position: absolute;
      // top: 159px;
      // right: 105px;
      width: 1.95rem;
      // height: 2.45rem;
      // min-height: 494px;
      box-sizing: border-box;
      padding: 0.08rem 0.1rem 0.08rem;
      background: radial-gradient(50% 37.8% at 50% 50%, rgba(255, 255, 255, 0.75) 28.47%, rgba(255, 255, 255, 0.315) 100%) ;
      border-radius: 12px;
      box-shadow: 0px -1px 25px rgba(214, 214, 214, 0.15);
      backdrop-filter: blur(56px);
      h2{
        font-family: 'Sofia Pro Bold';
        font-style: normal;
        font-weight: 700;
        font-size: 0.13rem;
        text-align: center;
        color: #3F5FED;
        line-height: 0.15rem;
        margin: 0 0 0.05rem;
      }
      /deep/.el-form-item{
        margin-bottom: 0.05rem;
      }
      /deep/ .el-form-item__label {
        font-family: 'Sofia Pro Bold';
        font-style: normal;
        font-weight: 700;
        font-size: 0.08rem;
        color: #111827;
        padding-bottom: 0.04rem;
      }
      button{
        border: 2px solid #FFFFFF;
        font-size: 0.075rem;
        font-weight: 700;
        /deep/span{
          font-family: "Sofia Pro SemiBold";
        }
      }
    }
    .imgbox{
        width: 2.5rem;
        // max-width:1.95rem ;
        display: flex;
        align-items: center;
        flex-wrap:wrap;
        margin: 0.04rem auto 0;
        justify-content: center;
        img{
          width: 0.68rem;
          // padding:  0.01rem;
        }
    }
    @media screen and (min-width: @device) {
      .wp-form {
        width: 372px;
        height: 100%;
      }
    }
    .round {
      position: absolute;
      width: 340px;
      height: 340px;
      right: 8px;
      top: -306px;

      background: white;

      box-sizing: border-box;
      border-radius: 50%;
      z-index: -1;
    }
  }
  .main-mid {
    background-color: #fff;
    max-width: 1076px;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    h1 {
      width: 486px;
      height: 102px;
      font-weight: 600;
      font-size: 40px;
      line-height: 53px;
      /* or 132% */

      text-align: center;
    }
    h5 {
      font-weight: 400;
      font-size: 11px;
      line-height: 16px;
      text-align: center;
      width: 413px;
      height: 34px;
    }
    .img_four {
      margin-top: 85px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      > div {
        height: 250px;
        width: 190px;
        .yellow_bg {
          width: 188.57px;
          height: 188.57px;
          background: rgba(255, 243, 204, 0.75);
          border-radius: 50%;
          display: flex;
          align-items: center;
          img {
            width: 195px;
            height: 130px;
          }
        }
        p {
          white-space: wrap;
          text-align: center;
        }
      }
    }
  }
  .main-btm {
    margin-top: 80px;
    max-width: 1076px;
    margin-bottom: 80px;
    margin-left: auto;
    margin-right: auto;
    background-color: #fff;
    h1 {
      font-weight: 600;
      font-size: 40px;
      line-height: 40px;
      text-align: center;
      color: #0b1d33;
    }
    //copy ->index
  }
  
    .star-container {
      margin-top: 80px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: center;
      justify-content: center;

      .star-left {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: auto;
        margin-right: auto;

        label {
          font-weight: 600;
          font-size: 21.654px;
          line-height: 100%;
          /* identical to box height, or 22px */

          text-align: center;

          color: #000000;
        }

        .star-img-big {
          width: 190.07px;
          height: 39.7px;
        }
      }
      
      .start-content{
          display: flex;
          margin-left:60px;
        margin-top:20px;
          .info-feed{
              
            box-shadow: 12px 8px 33px rgba(0, 0, 0, 8%);
            height: 179px;
            width: 201px;
            padding: 19px 13px;
            margin-right:40px;
            &:nth-child(3){
                margin-right: 0;
            }
            h6 {
                color: #000;
                // display: block;
                // width: 183px;
                font-size: 20px;
                z-index: 100040;
                line-height: 1.1;
                letter-spacing: 0;
                text-align: left;
                text-align-last: left;
                font-style: normal;
                display: block;
                margin: 0 11px;
                margin-bottom: 13px;
                font-family: "times new roman";
                font-weight: bold;
            }
            p {
                color: #000;
                display: block;
                // width: 177px;
                font-size: 14px;
                line-height: 1.4;
                letter-spacing: 0;
                font-style: normal;
                text-align: left;
                text-align-last: left;
                margin: 0 8px;
                font-family: "open sans";
            }
            img {
                height: 29px;
                width: 169px;
                margin-bottom: 6px;
            }
          }
      }
    }

}
@media screen and (max-width: @device) {
  /deep/.el-button{
    margin: 20px 0 0;
  }
   //验证码插件弹图位置
  /deep/ .yidun_intellisense--light .yidun_classic-container{
       bottom: 0;
       top: auto;
    }
   /deep/ .yidun_popup.yidun_popup--light .yidun_modal{
       bottom: 0;
       top: auto;
       left: 0;
       width: 100%;
       position: absolute;
    } 
    //-------------------------------
   /deep/ .el-scrollbar{
        min-width: 320px;
    }
  .bg {
    background:  #FFFFFF; 
    .top-cont{
      display: flex;
      flex-direction:column;
      .left{
        width: 100vw;
         -webkit-order: 2;
        order: 2;
        position: relative;
        background: #ECF2FF;
        height: 807px;
        .left-comment{
         position: relative;
         z-index: 9;
          text-align: center;
          h3{
            font-family: 'Sofia Pro Bold';
            font-style: normal;
            font-weight: 700;
            font-size: 32px;
            line-height: 40px;
            margin: 84px auto 24px;
            color: #111827;
            width: 345px;
          }
          div{
            display: table;
            margin: 0 auto;
          }
          div>div{
            display: flex;
            text-align: left; 
            margin: 0 20px ;
            margin-bottom: 24px;
            // display: flex;
            // align-items: center;
            img{
              width: 14px;
              height: 10px;
              margin-right: 17px;
              margin-top: 10px;
            }
            span{
              font-family: 'Sofia Pro SemiBold';
              font-style: normal;
              font-weight: 500;
              font-size: 20px;
              line-height: 24px;
              color: #111827;

            }
          }
        }

      }
      .right{
        background: #F5F5F5;
        -webkit-order: 1;
        order: 1;
        .right-reviews{
          width: 300px;
          margin: 19px auto 83px;
          display: flex;
          flex-direction:column;
          span{
            font-family: 'Roboto';
            font-style: normal;
            font-weight: 300;
            font-size: 16px;
            line-height: 22px;
            color: #000000;
            span{
              font-weight: 700;
            }
          }
          img{
            width: 237px;
            margin-bottom: 7px;
          }
          div{
            margin-bottom: 8px;
            display: flex;
            align-items: center;
            img{
              width: 25.36px;
              height: 24px;
              margin: 0;
            }
            span{
              font-weight: 500;
              font-size: 16px;
              line-height: 26px;
            }
          }
    }
        .class-form {
          width: 350px;
          height: 534px;
          margin: 30px auto 34px;
          box-sizing: border-box;
          padding:8px 32px 0px;
          background: radial-gradient(50% 37.8% at 50% 50%, rgba(255, 255, 255, 0.75) 28.47%, rgba(255, 255, 255, 0.315) 100%) ;
          border-radius: 12px;
          box-shadow: 0px -1px 25px rgba(214, 214, 214, 0.15);
          backdrop-filter: blur(56px);
          h2{
            font-family: 'Sofia Pro Bold';
            font-style: normal;
            font-weight: 700;
            font-size: 24px;
            text-align: center;
            color: #3F5FED;
            line-height: 40px;
            margin: 0 0 16px;
          }
          /deep/.el-form-item{
            margin-bottom: 8px;
          }
          /deep/ .el-form-item__label {
            font-family: 'Sofia Pro Bold';
            font-style: normal;
            font-weight: 700;
            font-size: 14px;
            color: #111827;
            padding-bottom: 4px !important;
          }
          button{
           
            border: 2px solid #FFFFFF;
            font-style: normal;
            font-weight: 700;
            font-size: 18px;  
            /deep/span{
              font-family: 'Sofia Pro Bold';
            }
          }
        }
        .imgbox{
            margin: 0px auto 60px;
            width: 365px;
            display: flex;
            flex-wrap:wrap;
            justify-content: center;
            align-items: center;
            .imggr1{
              width: 182px;
                // height: 93px;
                display: block;
            }


            .imggr2,.imggr3,.imggr4,.imggr5{
                width: 182px;
                display: block;

            }
            .imggr5{
                width: 230px;
            }
        }
      }
      .img1{
        display: none;
      }
      .img2{
        position: absolute;
        top: -10px;
        left: 38px;
        width: 30px;
      }
      .img3{
         display: none;
      }
      .img4{
         display: none;
      }
      .img5{
         display: none;
      }
      .img6{
        //  display: none;
        position: absolute;
        right: 0.3rem;
        bottom: 1.5rem;
        width: 0.18rem;
      }
      .img7{
         display: none;
      }
      .img8{
        position: absolute;
        bottom: 0;
        width: 747px;
        left: calc(50% - 373.5px);
         display: none;
      }
      .img9{
        position: absolute;
        z-index: 1;
        bottom: 0;
        width: 100%;
        left: 50%;/*绝对定位*/
        transform:translate(-50%);/*transform转换属性*/
      }
    }
  }

  .main-mid {
    background-color: #fff;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    h1 {
      width: 320px;
      height: 95px;
      font-weight: 600;
      font-size: 30px;
      line-height: 45px;
      text-align: center;

      color: #0b1d33;
    }
    h5 {
      width: 337px;
      height: 113px;
      font-family: "Poppins";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 23px;

      text-align: center;

      color: rgba(11, 29, 51, 0.6);
    }
    .img_four {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      > div {
        height: 290px;
        width: 190px;
        .yellow_bg {
          width: 188.57px;
          height: 188.57px;
          background: rgba(255, 243, 204, 0.75);
          border-radius: 50%;
          display: flex;
          align-items: center;
          img {
            width: 195px;
            height: 130px;
          }
        }
        p {
          font-weight: 500;
          font-size: 18px;
          line-height: 28px;

          text-align: center;

          color: #0b1d33;
        }
      }
    }
  }

  .main-btm {
    width: 100%;
    margin: 0;
    padding: 0;
    h1 {
      font-weight: 600;
      font-size: 26px;
      line-height: 39px;
      text-align: center;

      color: #0b1d33;
    }
    .star-left {
      width: 90%;
    }
    .over-list {
      width:100%;
    }
    .star-item {
      width: 90%;
    }
    .arrow-left,
    .arrow-right {
      display: none;
    }
    .star-item {
      border: 1px solid #f1f1f1;
      border-radius: 21px;
      padding: 25px 40px;
      box-sizing: border-box;
    }
    .star-left {
      margin-bottom: 30px;
    }
  }
  .star-container {
    justify-content: center;
      .start-content{
          display: flex;
          flex-direction: column;
          justify-content: center;
          .info-feed{
              
            box-shadow: 12px 8px 33px rgba(0, 0, 0, 8%);
            height: 179px;
            width: 201px;
            padding: 19px 13px;
            margin-bottom:40px;
            &:nth-child(3){
                margin-right: 0;
            }
            h6 {
                color: #000;
                // display: block;
                // width: 183px;
                font-size: 20px;
                z-index: 100040;
                line-height: 1.1;
                letter-spacing: 0;
                text-align: left;
                text-align-last: left;
                font-style: normal;
                display: block;
                margin: 0 11px;
                margin-bottom: 13px;
                font-family: "times new roman";
                font-weight: bold;
            }
            p {
                color: #000;
                display: block;
                // width: 177px;
                font-size: 14px;
                line-height: 1.4;
                letter-spacing: 0;
                font-style: normal;
                text-align: left;
                text-align-last: left;
                margin: 0 8px;
                font-family: "open sans";
            }
            img {
                height: 29px;
                width: 169px;
                margin-bottom: 6px;
            }
          }
      }
  }
}

  .star-container {
    margin-top: 80px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;

    .star-left {
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-left: auto;
      margin-right: auto;

      label {
        font-weight: 600;
        font-size: 21.654px;
        line-height: 100%;
        /* identical to box height, or 22px */

        text-align: center;

        color: #000000;
      }

      .star-img-big {
        width: 190.07px;
        height: 39.7px;
      }
    }

  }
  /deep/.el-input__inner:focus{
 border:1px solid hsl(0, 0%, 0%);
  }
  // /deep/.wp-input .el-input-group__prepend:focus{
  //   border:1px solid hsl(0, 0%, 0%);
  // }
   /deep/.wp-input .el-input-group__prepend:focus-within{
    border:1px solid hsl(0, 0%, 0%);
  }
  /deep/.el-input-group__prepend{
		background: #FFFFFF;
	}

  /deep/.el-input__inner{
    height: 44px;
     border: 1px solid #D1D5DB;
     box-sizing: border-box;
     color: #9CA3AF;
    //  border-radius: 6px;
  }
  /deep/.el-select{ 
    .el-input__inner{
      padding: 0 0 0 12px;
      font-weight: 500;
      font-size: 14px;
      color: #111827;
         background-image: -webkit-linear-gradient(left, rgba(0, 0, 0,1), rgba(0, 0, 0, 0.2));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .el-input__suffix{
       background: #FFFFFF;
        height: 38px;
        top:4px;
        right:0px;
        padding-right: 5px;
    }
    
}
/deep/ section .right .forms_submit .el-form .el-form-item .el-form-item__content .el-select .el-input__inner{
 
font-style: normal;
font-weight: 500;
font-size: 14px;
color: #111827;

}
.selectcss{
  width: 156px !important;
}
@media screen and (max-width: @device) {
    /deep/.el-input__inner{
      height: 40px;
    }
     /deep/.el-select{ 
       .el-input__suffix{
         height: 35px;
         right: 1px;
         top: 3px;
      }
     }
     /deep/.el-select .el-input {
    img{
        width: 17px;
        position: absolute;
        left: 12px;
        bottom: 13px;
    }
}
    .selectcss{
      width: 126px !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/freeTrial.vue